angular.module('jv.auditlog.directive', ['App.ajax.service'])
.factory('prepareAjaxCall', ['makeAjaxCall', function (makeAjaxCall) {
    var headerTypesMap= {
        json: {'Content-Type':'application/json; charset=UTF-8'},
        form: {'Content-Type':'application/x-www-form-urlencoded; charset=UTF-8'}
    };
    return function(args, options, onSuccess, onError){
        onSuccess = onSuccess || angular.noop;

        if(options['headerType']) {
            args.headers = headerTypesMap[options['headerType']];
        }
        var requestObj = args || {};
        requestObj.ajaxtype = options.ajaxtype;
        requestObj.url = options.url;
        requestObj.requestType = options.requestType || 'GET';
        requestObj.cache = options.cache || false;
        var requestPromise = makeAjaxCall(requestObj);

        requestPromise.then(function(results) {
            onSuccess(results.data,results.status);
        }, function(results) {
            onError(results.data, results.status);
        });
    };
}])
.factory('jvAuditLogService', ['prepareAjaxCall',
    function(prepareAjaxCall) {
        return function(params, url, callback, fail) {
            var options = {
                'ajaxtype': 'getAudtiLog',
                'url': url,
                'requestType': 'GET'
            };
            params.headers = {'Content-Type':'application/json; charset=UTF-8'};
            prepareAjaxCall(params, options, callback, fail);
        };
    }
])
.directive('jvAuditLog', ['$jobviteUrls', '$window', 'jvAuditLogService',
    function($jobviteUrls, $window, jvAuditLogService) {
        return {
            scope: {
                url: '=',
                action: '&'
            },
            link: function(scope) {
                scope.jvUrls = $window.jvUrls;
                scope.i18n = i18n;
                var state = scope.state = {
                    page: 0,
                    auditLogs: {},
                    expand: true
                };

                //replace placeholders with values
                var replacePlaceholders = function(placeholder, token, message) {
                    var actor = angular.copy(placeholder.objectText);
                    var toReplace;
                    var toSearch = angular.copy(token);
                    switch(placeholder.objectType) {
                        case 'ACTOR':
                            toReplace = angular.copy(actor);
                            break;
                        case 'REQUISITION_QUICK_LINK':
                            toReplace = '<a title="'+placeholder.objectText+'" ng-click="action({EId: \'' + placeholder.objectEId + '\',' + 'type: \'Requistion.QuickView\'})">'+placeholder.objectText+'</a>';
                            break;
                        default:
                            break;
                    }
                    var messageWithoutTokens = message.split(toSearch).join(toReplace);
                    return messageWithoutTokens;
                };


                var massageAuditResponse = function(data) {
                    angular.forEach(data, function(auditObject) {
                        angular.forEach(auditObject.placeholders, function(placeholder, key) {
                            var token = '{{'+key+'}}';
                            auditObject.title = replacePlaceholders(placeholder, token, auditObject.title);
                        });
                    });
                    return data;
                };

                var getAuditLog = function(page) {
                    var params = {
                        page: page
                    };
                    jvAuditLogService(params, scope.url, function(data) {
                        state.total = data.count;
                        state.pageSize = data.pageCount;
                        state.auditLogs = massageAuditResponse(data.resultList);
                    }, function() {
                        scope.$root.showMsg('UNABLE_TO_PERFORM_OPERATION', false, 'error');
                    });
                };

                getAuditLog(0);

                scope.next = function() {
                    state.page++;
                    getAuditLog(state.page);
                };

                scope.previous = function() {
                    state.page--;
                    getAuditLog(state.page);
                };
            },
            templateUrl: $jobviteUrls.currentContext + 'htm/common/auditLog.html'
        };
    }
])
.directive('jvAuditLogTitle', ['$compile', function($compile) {
    return function(scope, element, attrs) {
        scope.$watch(function(scope) {
            return scope.$eval(attrs.jvAuditLogTitle);
        }, function(value) {
            element.html(value);
            $compile(element.contents())(scope);
        });
    };
}]);
